import React from "react";

import {DropdownMenuItem} from "@reside/ui";

import {getResidentTestId} from "../../helper";
import {getWorkflowLabel} from "../../../dashboard-cell/WorkflowRibbon";
import {
  AdmissionFromSearch,
  downloadAdmissionPdf,
} from "../../../../services/AdmissionsService";
import {useDownloadManager} from "../../../../hooks/useDownloadManager";

export const DownloadPDFDropdownItem = ({
  admission,
  label,
  ...props
}: {
  admission: AdmissionFromSearch;
  label?: string;
}) => {
  const {start} = useDownloadManager();
  const resolvedLabel =
    label ??
    `Download ${
      // @ts-ignore - This is a temporary fix to allow the workflow_type to be used. It will be fixed in https://resideadmissions.atlassian.net/browse/DEV-5827
      getWorkflowLabel(admission.workflow_type ?? admission.workflowType) ||
      "Admission" // Default to admission because all old admissions are of type admission but they don't have a workflowType on them.
    }`;

  return (
    <DropdownMenuItem
      pointer
      onClick={() => {
        start(resolvedLabel, () =>
          downloadAdmissionPdf({
            admissionId: admission.id,
            type: "full",
            status: admission.status,
          }),
        );
      }}
      testId={getResidentTestId(admission, "downloadPdf")}
      {...props}
    >
      {resolvedLabel}
    </DropdownMenuItem>
  );
};
